import { Box, Heading, Flex } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next';
import Card from 'shared/components/horizon-ui/card/Card';
import InfiniteTable from 'shared/components/table/InfiniteTable';
import useGetColors from 'shared/hooks/useGetColors';
import { ModuleE, PathsE, PathsParams } from 'shared/routes';
import { useGetColumns, useGetGetBreadcrumbs } from './constants';
import { useParams } from 'react-router-dom';
import { useGetOneService, useGet3thPartyServices } from 'shared/api/requests/services';
import PageTitle from 'shared/views/admin/PageTitle';
import { ActorsT } from 'shared/api/types/services';
import { TableNameE } from 'shared/api/types/common';

const Index = () => {
  const { serviceId } = useParams<PathsParams[PathsE.ACTORS]>();

  const { data: currentService } = useGetOneService({
    pathParams: { serviceId },
    params: undefined
  });

  const { t } = useTranslation();
  const { blue800 } = useGetColors();

  const columns = useGetColumns({ serviceId });
  const breadcrumbs = useGetGetBreadcrumbs();

  const { useGetServiceModule } = useGet3thPartyServices({
    domain: currentService?.domain,
    token: currentService?.token,
    module: ModuleE.ACTORS
  });

  if (!currentService) return null;

  return (
    <Box>
      <PageTitle title={t('services.actors')} breadcrumbs={breadcrumbs} />
      <Card mb="20px" borderRadius="20px" px="30px">
        <Flex alignItems="center">
          <Heading size="md" color={blue800}>
            {t('services.actorsTable')}
          </Heading>
        </Flex>
        <InfiniteTable<ActorsT>
          query={useGetServiceModule as FixMeLater}
          columns={columns}
          filterFields={[]}
          tableName={TableNameE.ACTORS}
        />
      </Card>
    </Box>
  );
};

export default Index;
